import React from 'react';
import './About.css';
import azureLogo from '../assets/images/Azure.png';
import office365Logo from '../assets/images/Office365.png';
import hyperVLogo from '../assets/images/Hyper-V.png';
import nableLogo from '../assets/images/N-able.png';
import sqlLogo from '../assets/images/SQL.png';
import atlassianLogo from '../assets/images/Atlassian.png';
import connectwiseLogo from '../assets/images/Connectwise.png';

const About = () => {
  const techLogos = [
    { src: azureLogo, alt: 'Azure Logo', name: 'Microsoft Azure' },
    { src: office365Logo, alt: 'Office 365 Logo', name: 'Microsoft InTune' },
    { src: hyperVLogo, alt: 'Hyper-V Logo', name: 'Hyper-V' },
    { src: nableLogo, alt: 'N-able Logo', name: 'N-able' },
    { src: sqlLogo, alt: 'SQL Logo', name: 'SQL' },
    { src: atlassianLogo, alt: 'Atlassian Logo', name: 'Atlassian' },
    { src: connectwiseLogo, alt: 'Connectwise Logo', name: 'Connectwise' }
  ];

  const skills = [
    'Cloud & Infrastructure',
    'Security & Monitoring',
    'Database Management',
    'Systems Administration',
    'Project Management',
    'Cyber Security',
    'Team Leadership',
    'Sales Team Training'
  ];

  return (
    <section id="about" className="about">
      <div className="terminal-container">
        <div className="terminal-header">
          <span className="terminal-title">About Me</span>
        </div>
        <div className="terminal-body">
          <h2 className="section-title">Professional Profile</h2>
          <p className="section-subtitle">
            Experienced IT professional with expertise in deployment, system administration,
            team leadership, and training sales teams to confidently position and sell
            technology solutions to customers.
          </p>

          <div className="skills-container">
            {skills.map((skill, index) => (
              <span key={index} className="skill-tag">
                {skill}
              </span>
            ))}
          </div>

          <div className="tech-logos">
            {techLogos.map((logo, index) => (
              <img
                key={index}
                src={logo.src}
                alt={logo.alt}
                className="tech-logo"
                title={logo.name}
              />
            ))}
          </div>

          <div className="social-links">
            <a
              href="https://www.linkedin.com/in/tim-patterson-22659155/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              title="LinkedIn Profile"
            >
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
